var Zakeke;
(function (Zakeke) {
    var Home;
    (function (Home) {
        $(document).ready(function () {
            // "question" items behaviour
            $('.question').on("click", function () {
                $(this).siblings('.answer').stop().fadeToggle();
                $(this).find('.material-icons').stop().fadeToggle();
            });
            /**/
            // card label behaviour
            $('#label-card-pricing').on("click", function () {
                resetCardFAQ();
                $(this).addClass('label-card-selected');
                $('#pricing-faq').fadeIn(300);
            });
            $('#label-card-commercial').on("click", function () {
                resetCardFAQ();
                $(this).addClass('label-card-selected');
                $('#commercial-faq').fadeIn(300);
            });
            $('#label-card-tech').on("click", function () {
                resetCardFAQ();
                $(this).addClass('label-card-selected');
                $('#tech-faq').fadeIn(300);
            });
            /**/
            // Select pricing as first card
            $("#label-card-pricing").click();
        });
        /**/
        function resetCardFAQ() {
            $('.label-card').removeClass('label-card-selected');
            $('.container-faq').hide();
            $('.answer').hide();
            $('.open-answer').show();
        }
    })(Home = Zakeke.Home || (Zakeke.Home = {}));
})(Zakeke || (Zakeke = {}));
